module.exports = __webpack_public_path__ + "img/help_toolbar.aa04cc41.png";